export default __webpack_public_path__ + "static/media/grey-circle.94be4ee1.svg";